import React from 'react';
import QuickRegister from './components/QuickRegister';

export const Children = {
  'check-in': QuickRegister,
};
